"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatch = dispatch;

var _Dispatch = require("../dispatch/Dispatch");

/**
 * DEPRECATED
 * ==========
 * This method exists for backwards compatibility.
 * Prefer one of the explicit dispatch methods in `crm_data/dispatch/Dispatch`.
 *
 * `dispatch` behaves similarly to `dispatchSafe` but will warn if it is called
 * within another dispatch.
 *
 * @param  {string}   actionType
 * @param  {any}      data
 */
function dispatch(actionType, data) {
  (0, _Dispatch.dispatchImmediate)(actionType, data);
}